<!-- eslint-disable camelcase -->
<!-- eslint-disable camelcase -->
<template>
  <div class="page">
    <!--  -->
    <van-notice-bar v-if="h5Config.funCfg.openFace && !faceImg"  mode="link" @click="bindFaceEntrance" left-icon="info-o">请绑定人脸信息，以免影响使用</van-notice-bar>
    <div class="content_box">
      <div class="condition-wrap">
        <div class="selectDayBox">
          <div class="condition-data-date" @click="openTimePopup">
            {{ selDate }}
          </div>
          <van-popup v-model="showPopup" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择年月日"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="timePickerConfirm"
              @cancel="timePickerCancel"
              @change="bindDateChange"
            >
            </van-datetime-picker>
          </van-popup>

          <!-- <picker
          mode="date"
          value="{{selDate}}"
          start="{{todayDate}}"
          end="appointEndDate"
          @click="closeTimePicker"
          bindchange="bindDateChange"
        >
          <div class="condition-data-date">
            {{ selDate }}
          </div>
        </picker> -->
          <!-- <div
          :class="[
            'conditionDataDateTimeDiv',
            selectedDateIndex === 0 ? 'buildingParentected' : '',
          ]"
          @click="changeDayDate(0)"
        >
          今天
        </div> -->
          <!-- <div
          :class="[
            'conditionDataDateTimeDiv',
            selectedDateIndex === 1 ? 'buildingParentected' : '',
          ]"
          @click="changeDayDate(1)"
        >
          明天
        </div> -->
          <div class="condition-data-time" @click="getTimeColumnAndShowColumn">
            {{
              filterData.startTime && filterData.endTime
                ? filterData.startTime + '-' + filterData.endTime
                : '全天'
            }}
          </div>
        </div>

        <div v-if="h5Config.funCfg.openScanCode" class="saoyisao" @click="scanQRCode">
          <van-icon name="scan" />
        </div>
      </div>
      <!-- 楼号 -->
      <div
        v-if="buildingData.length > 0"
        :class="[
          'buildingParent',
          buildingData.length > 2 || buildingData.length == 1
            ? 'buildingParent-x'
            : '',
        ]"
      >
        <div
          :class="[
            'building',
            selBuildingData.buildingNo == item.buildingNo
              ? 'buildingParent'
              : '',
          ]"
          v-for="item in buildingData"
          :key="item.id"
          @click="buildingParentectBuilding(item)"
        >
          <div class="text">{{ item.title }}{{ (h5Config.funCfg && h5Config.funCfg.buildNoUnit) || ''}}</div>
          <img src="../../assets/imgs/building-select.png" class="icon" />
          <!-- <span v-else></span> -->
        </div>
      </div>
      <!-- 楼层 -->
      <transition name="fade" appear>
        <div v-if="selBuildingData" class="buildingParentect">
          <div class="outer-layerParent">
            <div class="inner-layerParent"
                 ref="layerWrap"
                 @mousedown="mousedown"
                 @mousemove="mousemove"
                 @mouseup="mouseup"
                 @mouseleave="mouseleave">
              <div ref="layer"
                  :class="[
                    'layerParent',
                    selBuildingData.layerData.length > 3 ? 'layerParentX' : '',
                  ]">
                <div :class="[
                        'item',
                        selLayerData.layerNo == item.layerNo ? 'buildingParent' : '',
                      ]"
                      v-for="item in selBuildingData.layerData"
                      :key="item.id"
                      @click="selectLayer(item)">
                  <div class="text">{{ item.title }}{{ (h5Config.funCfg && h5Config.funCfg.floorNoUnit) || ''}}</div>
                  </div>
                <div />
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 琴房预览 -->
      <div class="index-qinfang-wrap" :style="h5Config.funCfg.openFace && !faceImg?topWrapHeight2:topWrapHeight" ref="scrollContainer" @scroll="handleScroll">
        <!-- 琴房列表预览 -->
        <div
          v-if="layerModel == 1"
          style="width: 100%; height: 100%"
          scroll-y="true"
          :scroll-top="roomScrollTop"
        >
          <div class="room-list">
            <div
              v-for="item in roomData"
              :key="item.id"
              class="room"
              :style="{
                visibility: item.fill_element ? 'hidden' : 'visible',
              }"
              @click="selectRoom(item)"
            >
              <div class="room-top">
                <div class="back-img-wrap" v-if="item.occupation">
                  <img
                      mode="scaleToFill"
                      :src="roomBackgroundImg[item.occupation]"
                  />
                </div>
                <div :class="['room-up', h5Config.funCfg.showRoomListManyName ? 'many-room-up' : '']">
                  <span :class="['no-text',h5Config.funCfg.showRoomListManyName ? 'many-no-text' : '']">{{ item.name }}</span>
                </div>
                <div :class="['room-down']">
                  <span class="type-text">{{ item.type_name }}</span>
                  <span class="device-name"
                  >{{ item.has_instrument == 1 ? '· ' : ''
                    }}<span>
                    <!-- {{item.has_instrument == 1 ? '钢琴' : ''}} -->
                  </span></span>
                </div>
              </div>
              <div
                :class="[
                  'roomBookDetail',
                  roomDetailBackground[item.occupation],
                ]"
                v-if="h5Config.funCfg.showRoomListDetail"
              >
                <div
                  v-for="detailItem in item.room_book_times"
                  :key="detailItem.id"
                  :class="[
                    'roomBookDetailItem',
                    item.occupation === -2 ||
                    item.occupation === -1 ||
                    detailItem.overdueCur
                      ? 'line-through'
                      : '',
                  ]"
                >
                  <span
                    >{{ detailItem.startTime }}~{{ detailItem.endTime }}</span
                  >
                </div>
                <div class="room-book-detail-empty"></div>
                <div class="room-book-detail-empty"></div>
              </div>
            </div>
            <div
              class="emptyBox"
              v-if="roomData !== null && roomData.length === 0"
            >
              <van-empty description="暂无数据" />
            </div>

            <!-- <div class="room-bottom-fill{{selRoomData ? '-buildingParent' : ''}}"/> -->
          </div>
        </div>
        <!-- 琴房指示预览 -->
        <block v-if="elImageChange && layerModel == 2">
          <div style="width: 100%; height: 100%">
            <movable-area
              style="width: 100%; height: 100%; overflow: hidden"
              scale-area
            >
              <movable-view
                style="height: 100%; width: 100%"
                direction="all"
                out-of-bounds
                scale
                scale-min="1"
                id="movable-views"
              >
                <image
                  v-if="selLayerData"
                  class="svg-image"
                  :style="`width:${(movable.width * 4) / 2}px;height:${
                    (movable.height * 4) / 2
                  }px; `"
                  :src="selLayerData.image"
                  mode="aspectFit"
                ></image>
              </movable-view>
            </movable-area>
          </div>
        </block>
        <block v-if="!elImageChange && layerModel == 2">
          <div style="width: 100%; height: 100%">
            <movable-area
              style="width: 100%; height: 100%; overflow: hidden"
              scale-area
            >
              <movable-view
                style="height: 100%; width: 100%"
                direction="all"
                out-of-bounds
                scale
                scale-min="1"
                id="movable-views"
              >
                <image
                  v-if="selLayerData"
                  class="svg-image"
                  :style="`width:${(movable.width * 4) / 2}px;height:${
                    (movable.height * 4) / 2
                  }px; `"
                  :src="selLayerData.image"
                  mode="aspectFit"
                ></image>
              </movable-view>
            </movable-area>
          </div>
        </block>
        <div
          v-if="layerModel == 1 && showReload"
          class="reload-room"
          @click="reloadRoom"
        >
          重新加载
        </div>
      </div>
      <div v-if="selRoomData" class="subscribe-parent">
        <div class="subscribe-top">
          <img
            class="subscribe-close"
            src="../../assets/imgs/close.png"
            @click="clearbuildingParentRoom"
          />
          <div class="subscribe-address">
            {{
              selBuildingData.title +
              ' ' +
              selLayerData.title2 +
              ' ' +
              selRoomData.name
            }}
          </div>
          <div class="subscribe-time-parent">
            <text class="subscribe-time-hint">可预约时长：</text>
            <text class="subscribe-time"
              >{{ selRoomData.canTime ? selRoomData.canTime : '' }}
            </text>
          </div>
          <div class="subscribe-dispose">
            <div class="type-name">{{ selRoomData.type_name }}</div>
            <!-- <div class="has-instrument" v-if="{{selRoomData.has_instrument == 1}}">
        钢琴
        </div>
        <div class="has-window" v-if="{{selRoomData.has_window == 1}}">
        有窗
        </div> -->
          </div>
        </div>
        <div class="subscribe" @click="roomSubscribe">预约</div>
      </div>
      <wizard />
      <!-- 时间选择picker -->
      <div class="time-picker-filter" v-if="filterData.show">
        <div class="time-picker-filter-top">
          <div class="time-picker-filter-top-left">预约时间</div>
          <img
            class="time-picker-filter-top-close"
            src="../../assets/imgs/close.png"
            mode=""
            @click="closeTimePicker"
          />
        </div>
        <div class="filter-fast-time-div">
          <div
            :class="[
              'conditionDataDateTimeDiv',
              filterData.startTime == '' && filterData.endTime == ''
                ? 'buildingParentected'
                : '',
            ]"
            @click="bindDateTimeChange('all')"
          >
            全天
          </div>
          <div
            :class="[
              'conditionDataDateTimeDiv',
              filterData.startTime == '06:00' && filterData.endTime == '12:00'
                ? 'buildingParentected'
                : '',
            ]"
            @click="bindDateTimeChange('am')"
          >
            上午
          </div>
          <div
            :class="[
              'conditionDataDateTimeDiv',
              filterData.startTime == '12:00' && filterData.endTime == '18:00'
                ? 'buildingParentected'
                : '',
            ]"
            @click="bindDateTimeChange('pm')"
          >
            下午
          </div>
          <div
            :class="[
              'conditionDataDateTimeDiv',
              filterData.startTime == '18:00' && filterData.endTime == '22:00'
                ? 'buildingParentected'
                : '',
            ]"
            @click="bindDateTimeChange('evening')"
          >
            晚上
          </div>
        </div>
        <div class="filter-time-picker-wrap">
          <div class="time-picker-start-wrap">
            <div class="temp-time-wrap">
              <div
                :class="[
                  'temp-time-text',
                  filterTempData.startTime ? 'val' : '',
                ]"
              >
                {{ filterTempData.startTime || '开始时间' }}
              </div>
            </div>
            <!-- add new  -->

            <!-- <picker-view
              indicator-class="bottom-time-filter-picker-indicator"
              class="bottom-time-filter-picker"
              bindpickstart="bindpickstart"
              :value="filterTempData.startIndex"
              bindchange="bindTimePickerStartChange"
            >
              <picker-view-column>
                <div
                  v-for="item in timeColumnList"
                  :key="item.id"
                  style="line-height: 50px; text-align: center"
                >
                  {{ item }}
                </div>
              </picker-view-column>
            </picker-view> -->
          </div>
          <div class="filter-zhi">至</div>
          <div class="time-picker-end-wrap">
            <div class="temp-time-wrap">
              <div
                :class="['temp-time-text', filterTempData.endTime ? 'val' : '']"
              >
                {{ filterTempData.endTime || '结束时间' }}
              </div>
            </div>
            <!-- <picker-view
              indicator-class="bottom-time-filter-picker-indicator"
              class="bottom-time-filter-picker"
              bindpickstart="bindpickstart"
              :value="filterTempData.endIndex"
              bindchange="bindTimePickerEndChange"
            >
              <picker-view-column>
                <div
                  v-for="item in timeColumnList"
                  :key="item.id"
                  style="line-height: 50px; text-align: center"
                >
                  {{ item }}
                </div>
              </picker-view-column>
            </picker-view> -->
          </div>
        </div>
        <!-- 多列选择器 -->
        <van-picker
          ref="vanTimePicker"
          :columns="columns"
          visible-item-count="3"
          @change="timesChange"
          @confirm="timesConfirm"
          @cancel="timesCancel"
        />
        <div class="book-confirm-div-bottom">
          <div class="book-comfirm-div-wrap">
            <van-button
              class="doneBtn"
              @click="doQuery"
              :disabled="filterTempData.comfirmDisabled"
            >
              完成
            </van-button>
          </div>
        </div>
      </div>
      <div class="complaint-wrap">
        <!-- <div
          class="view"
          :style="`top:${floatButton.top / 2}px;left:${
            floatButton.left / 2
          }px;margin: 0% 0px 0px 0%;z-index: 999;`"
        ></div> -->
        <!-- <div
          class="view"
          :style="`bottom:2rem;right:1rem;margin: 0% 0px 0px 0%;z-index: 999;`"
          @click="feedBack"
        >

          <img
            style="height: 2.5rem; width: 2.5rem; border-radius: 50%"
            src="../../assets/imgs/complaint.png"
          />

        </div> -->
         <floatBtn></floatBtn>
<!--        <control v-if="showController"></control>-->

      </div>
    </div>
  </div>
</template>
<script>
import wizard from './wizard.vue'
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import * as constant from '../../api/constant'
import { Toast, Dialog } from 'vant'
import { mapGetters } from 'vuex'
import floatBtn from '../common/floatBtn.vue'
// import control from '../common/control.vue'
// import store from '../../store'

export default {
  components: {
    wizard,
    floatBtn
    // ,
    // control
  },
  data () {
    // const today = new Date()
    // const tomorrow = new Date()
    return {
      minDate: new Date(),
      maxDate: new Date(),
      // maxDate: new Date(new Date().valueOf() + 24 * 60 * 60 * 1000),
      currentDate: '',
      roomScrollTop: 0, // 刷新后room列表滚动到顶部
      elImageChange: true, // 用来重新绘制缩放区域
      showReload: false, // 是否显示重新加载room列表按钮
      selRoomData: null, // 选中的room数据
      selDateText: '', // 选中的日期文本
      selDate: '', // 选中的日期
      todayDate: '', // 用来对比是否是今天的日期
      appointEndDate: '', // 日期选择器结束日期
      selBuildingData: null, // 选中的楼
      selLayerData: null, /// /选中的层
      layerModel: 1, // 1 图片预览  2列表预览
      roomData: null, // room列表数据
      roomTypeData: null, // 琴房类型列表
      filterData: {
        isFilter: false,
        show: false,
        startTime: '',
        endTime: '',
        selRoomTypeData: null // 选中的筛选琴房条件
      },
      filterTempData: {
        startTime: '',
        endTime: '',
        startIndex: [0],
        endIndex: [0],
        comfirmDisabled: false
      },
      buildingData: [], // 楼数据
      movable: {
        width: 0,
        height: 0
      },
      // motto: 'Hello World',
      // userInfo: {},
      // hasUserInfo: false,
      // canIUse: wx.canIUse('button.open-type.getUserInfo')
      floatButton: {
        left: 0,
        top: 0
      },
      rpx: 0,
      windowHeight: 0,
      selectedDateIndex: 0,
      timeColumnList: [], // 时间选择器column列表
      roomBackgroundImg: {
        '-2': require('../../assets/imgs/index-wizard/lock.png'),
        '-1': require('../../assets/imgs/index-wizard/disable.png'),
        // '0': '../../images/index-wizard/disable.png',
        1: require('../../assets/imgs/index-wizard/part.png'),
        2: require('../../assets/imgs/index-wizard/all.png')
      },
      roomDetailBackground: {
        '-2': 'lockOrder',
        '-1': 'disableOrder',

        1: 'partOrder',
        2: 'allOrder'
      },

      showPopup: false,
      configInfo: {},
      columns: [
        // 第一列
        {
          values: ['周一', '周二', '周三', '周四', '周五'],
          defaultIndex: 0
        },
        // 第二列
        {
          values: ['上午', '下午', '晚上'],
          defaultIndex: 0
        }],
      scrollHeight: 0,
      scrollLayerLeft: 0,
      topWrapHeight: {
        top: '9.0625rem'
      },
      topWrapHeight2: {
        top: '11.5625rem'
      },
      layerSelected: {
        x: 0,
        selected: false
      },
      showController: false
    }
  },
  created () {
    this.checkPreviousRoute()
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'h5Config',
      'face'
    ]),
    userInfoJSONParse () {
      return JSON.parse(this.userInfo) ? JSON.parse(this.userInfo) : null
    },

    faceJSONParse () {
      return this.face ? JSON.parse(this.face) : null
    },
    faceImg () {
      return this.face ? JSON.parse(this.face) : ''
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     if (from.path === '/orderResult' || from.path === '/pianoOrder' || from.path === '/login') {
  //       vm.getLayerRoom()
  //     }
  //   })
  // },
  methods: {
    getMyOrder () {
      const curTime = new Date()
      const endTime = new Date()
      const now = new Date()
      curTime.setHours(0)
      curTime.setMinutes(0)
      curTime.setSeconds(0)
      endTime.setHours(23)
      endTime.setMinutes(59)
      endTime.setSeconds(59)
      const para = {
        book_audit_type: true,
        start_time: common.dateFormat(curTime, 'yyyy-MM-dd hh:mm:ss')
      }
      api.axiosRequest(api.urlList.historyOrder, para).then(res => {
        if (res.code === common.resCode.OK) {
          for (let i = 0; i < res.list.length; i++) {
            const item = res.list[i]
            if (item.status === 5 && new Date(item.end_time) > now) {
              this.room_id = item.room_id
            }
          }
          if (this.room_id) {
            this.showController = true
          }
        }
      })
    },
    init () {
      this.$nextTick(() => {
        const realHeight = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight
        this.setMetaHeight(realHeight)
      })
      this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll)

      this.getPianoTimeConfig()
      // let configInfo=sessionStorage.getItem('configInfo')
      // this.configInfo=configInfo
      this.getToday()
      // this.getBuildingInfo()
      this.getOnShow()

      this.getWin()
      this.getLimitDate()
      this.getMyOrder()
      // if (app.globalData.passworsdSimplenessHint) {
      // if (app.globalData.passworsdSimplenessHint) {
      // app.globalData.passworsdSimplenessHint = false
      const passwordCheck = localStorage.getItem('passwordCheck')

      if (passwordCheck === '1') {
      // localStorage.setItem('passwordCheck', '0')
        api.setPasswordCheck('0')
        Dialog.confirm({
          title: '提示',
          message: '您的密码安全性弱，请及时修改密码！',
          confirmButtonText: '去修改',
          cancelButtonText: '暂不修改'

        }).then(() => {
        // on confirm
          this.$router.push('/updatePassword')
        }).catch(() => {
        // Toast('cancel')
        })
      }
      this.judgeTodayIsOpenDay(new Date().getDay())
    },
    checkPreviousRoute () {
      // 获取跳转来源的路由路径
      const fromRoutePath = this.$route.from ? this.$route.from.path : ''

      // 判断是否是从 result 页面跳转而来
      if (fromRoutePath === '/orderResult') {
        // 这里可以执行相关逻辑
      }
    },

    // 新增人脸
    bindFaceEntrance () {
      this.$router.push('/announcements')
      // 以下是办公室测试
      // this.$router.push('/officeCollection')
    },
    // 判断 选择日期 是否在配置的开放日期范围内
    judgeTodayIsOpenDay (dayPara) {
      if (!this.configInfo || Object.keys(this.configInfo).length === 0) {
        // Dialog.alert({
        //   title: '提示',
        //   message: '配置加载出错'
        // }).then(() => {
        //   // on confirm
        // })
        return
      }
      if (this.h5Config.funCfg.openRoomTimeRule) {
        return true
      }
      const pt = this.configInfo.piano_open_time
      let open = false
      if (Array.isArray(pt)) {
        if (pt.length === 1 && Array.isArray(pt[0].weeks) && pt[0].weeks.length === 0) {
          // 全周开放
          open = true
        } else {
          for (let i = 0; i < pt.length; i++) {
            if (Array.isArray(pt[i].weeks) && pt[i].weeks.includes(dayPara)) {
              open = true
              break
            }
          }
        }
      } else {
        open = true
      }

      if (!open) {
        const whatDay = utils.judgeTodayWhatDay(dayPara)
        Dialog.alert({
          title: '提示',
          message: '当前日期为：' + whatDay + '，非开放日期，可预约其它日期。如需预约该天，请联系管理员'
        }).then(() => {
          // on confirm
        })
      }
      return open
    },
    getLimitDate () {
      const currentDate = utils.formatTimeYMDInterval(new Date(), '-')
      this.minDate = new Date(currentDate)

      this.getPianoTimeConfig()
      const configData = JSON.parse(localStorage.getItem(common.keyConfigInfo))

      let aheadLimit = 0
      this.configInfo = configData

      if (configData) {
        aheadLimit = this.configInfo.ahead_limit
      }
      if (aheadLimit > 0) {
        const curTime = new Date()

        const selDate = utils.formatDate(this.selDate + ' 00:00:00')

        const appointEndDate = utils.formatTimeYMDInterval(new Date(new Date().setDate(curTime.getDate() + aheadLimit - 1)), '-')
        const difValue = this.dayDifValue(selDate, curTime)
        if (difValue < 0 || difValue > (aheadLimit - 1)) {
          if (this.buildingData.length) {
            const bdData = this.buildingData[0]

            this.selDateText = utils.formatTimeYMDChinese(curTime)
            this.selDate = utils.formatTimeYMDInterval(curTime, '-')
            this.selBuildingData = bdData
            this.selLayerData = bdData.layerData[0]
            this.layerModel = 1
            this.selRoomData = null
            this.maxDate = new Date(appointEndDate)
          } else {
            this.selDateText = utils.formatTimeYMDChinese(curTime)
            this.selDate = utils.formatTimeYMDInterval(curTime, '-')
            this.layerModel = 1
            this.selRoomData = null
            this.maxDate = new Date(appointEndDate)
          }
          this.getLayerRoom()
        } else {
          this.maxDate = new Date(appointEndDate)
        }
      } else {

      }
    },
    // 扫一扫签到
    scanQRCode () {
      this.$router.push('/qrCodeWrap')
    },
    // 手动重新加载
    reloadRoom () {
      this.getLayerRoom()
    },

    roomSubscribe () {
    },

    // 点击楼层
    selectLayer (val) {
      if (this.layerModel === 2) {
        this.elImageChange = !this.elImageChange
        this.selLayerData = val
        this.selRoomData = null

        this.setMovableView()
      } else {
        this.selLayerData = val
        this.selRoomData = null
      }
      this.getLayerRoom()
      this.layerScroll()
    },
    setMovableView () {
      //  const query = wx.createSelectorQuery()
      //     query && query.select('#movable-views').boundingClientRect()
      //     query && query.exec((res) => {
      //       console.log('setMovableView', res)
      //       if (res[0]) {
      //         let widthTotal = res[0].width
      //         this.setData({
      //           movable: {
      //             width: res[0].width,
      //             height: res[0].height
      //           }
      //         })
      //       }
      //     })
    },
    dayDifValue (date1, date2) {
      const oneDayMillisecond = 1000 * 60 * 60 * 24
      const str1 = utils.formatTimeYMDInterval(date1, '-') + ' 00:00:00'
      const str2 = utils.formatTimeYMDInterval(date2, '-') + ' 00:00:00'
      let new1, new2
      if (utils.judgeClient() !== constant.judgeClientType.Android) {
        new1 = new Date(str1.replace(/-/g, '/'))
        new2 = new Date(str2.replace(/-/g, '/'))
      } else {
        new1 = new Date(str1)
        new2 = new Date(str2)
      }
      const diff = new1.getTime() - new2.getTime()
      return (diff - diff % oneDayMillisecond) / oneDayMillisecond
    },
    getOnShow () {
      const currentDate = utils.formatTimeYMDInterval(new Date(), '-')

      this.todayDate = currentDate

      this.setMovableView()
      const configInfo = JSON.parse(localStorage.getItem(common.keyConfigInfo))
      this.configInfo = configInfo
      let aheadLimit = 0
      if (configInfo) {
        aheadLimit = configInfo.ahead_limit
      }
      if (aheadLimit > 0) {
        let selDate
        const curTime = new Date()
        if (utils.judgeClient() !== constant.judgeClientType.Android) {
          selDate = new Date(this.selDate.replace(/-/g, '/') + ' 00:00:00')
        } else {
          selDate = new Date(this.selDate + ' 00:00:00')
        }
        const appointEndDate = utils.formatTimeYMDInterval(new Date(new Date().setDate(curTime.getDate() + aheadLimit - 1)), '-')
        const difValue = this.dayDifValue(selDate, curTime)
        if (difValue < 0 || difValue > (aheadLimit - 1)) {
          if (this.buildingData.length) {
            const bdData = this.buildingData[0]
            this.selDateText = utils.formatTimeYMDChinese(curTime)
            this.selDate = utils.formatTimeYMDInterval(curTime, '-')
            this.selBuildingData = bdData
            this.selLayerData = bdData.layerData[0]
            this.layerModel = 1
            this.selRoomData = null
            this.appointEndDate = appointEndDate
          } else {
            this.selDateText = utils.formatTimeYMDChinese(curTime)
            this.selDate = utils.formatTimeYMDInterval(curTime, '-')
            this.layerModel = 1
            this.selRoomData = null
            this.appointEndDate = appointEndDate
          }
        } else {
          this.appointEndDate = appointEndDate
        }
      } else {
      }
    },
    buildingParentectLayer () {
    },
    // 楼号
    buildingParentectBuilding (item) {
      console.log('打印楼号', item)
      if (this.selBuildingData.buildingNo === item.buildingNo) {
        return false
      }
      if (this.layerModel === 2) {
        this.elImageChange = !this.elImageChange
        this.selBuildingData = item
        this.selLayerData = item.layerData[0]
        this.selRoomData = null

        this.setMovableView()
      } else {
        this.selBuildingData = item
        this.selLayerData = item.layerData[0]
        this.selRoomData = null
      }
      this.getLayerRoom()
      this.layerScroll()
    },

    // 加载房间列表
    async getLayerRoom () {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      this.showReload = false
      const that = this
      const dateYmd = that.selDate
      const para = {
        building_no: that.selBuildingData.buildingNo,
        building_floor: that.selLayerData.layerNo,
        book_date: dateYmd,

        begin_time: dateYmd + ' ' + (that.filterData.startTime === '' ? '00:00' : that.filterData.startTime) + ':00',
        end_time: dateYmd + ' ' + (that.filterData.endTime || '23:59') + ':00',
        get_all_book: true,
        support_time_rule: that.h5Config.funCfg.openRoomTimeRule
      }
      if (that.filterData.selRoomTypeData) {
        para.type_id = that.filterData.selRoomTypeData.id
      }
      const res = await api.axiosRequest(api.urlList.getFloorDetail, para)
      Toast.clear()
      if (res && res.code === common.resCode.OK) {
        if (res.list) {
          const filterStartTime = new Date(para.begin_time.replace(/-/g, '/'))
          const filterEndTime = new Date(para.end_time.replace(/-/g, '/'))
          const selectStartMinutes = filterStartTime.getHours() * 60 + filterStartTime.getMinutes()
          const selectEndMinutes = filterEndTime.getHours() * 60 + filterEndTime.getMinutes()
          const selDate = utils.formatDate(this.selDate + ' 00:00:00')
          const forbiddenRooms = res.forbidden_rooms || []
          let userId
          try {
            if (this.userInfoJSONParse) {
              userId = Number(this.userInfoJSONParse.userid)
            }
          } catch (e) {
            console.log(e)
          }
          if (that.h5Config.funCfg.openRoomTimeRule) {
            await this.getConfig()
            if (Array.isArray(res.time_rule_list)) {
              for (let c = 0; c < res.time_rule_list.length; c++) {
                res.time_rule_list[c].quantum = utils.getTimeQuantum(res.time_rule_list[c].quantum, res.time_rule_list[c].book_interval)
              }
            }
            for (let d = 0; d < res.list.length; d++) {
              const room = res.list[d]
              let quantum = []
              if (Array.isArray(res.time_rule_list)) {
                for (let f = 0; f < res.time_rule_list.length; f++) {
                  if (res.time_rule_list[f].room_ids.includes(room.id)) {
                    quantum = res.time_rule_list[f].quantum
                    break
                  }
                }
              }
              const filterQuantum = utils.filterTimeQuantum(quantum, selectStartMinutes, selectEndMinutes)
              that.checkCanUseStatus(room, JSON.parse(JSON.stringify(filterQuantum)), userId)

              const bookObj = Array.isArray(res.all_room_books) && res.all_room_books.find(function (v) {
                return v.room_id === room.id
              })
              room.room_book_times = await this.getPianoOneDayReservedEveryRoom(bookObj ? bookObj.all_room_books : [], {
                selDate: selDate,
                timeQuantumList: quantum
              }, room, forbiddenRooms)
            }
          } else {
            const originSelectSpanList = await that.getTimeQuantumList(selectStartMinutes, selectEndMinutes)
            const pianoOrderConfig = await this.getAllPianoConfig()
            for (let d = 0; d < res.list.length; d++) {
              const room = res.list[d]
              that.checkCanUseStatus(room, JSON.parse(JSON.stringify(originSelectSpanList)), userId)

              const bookObj = Array.isArray(res.all_room_books) && res.all_room_books.find(function (v) {
                return v.room_id === room.id
              })
              room.room_book_times = await this.getPianoOneDayReservedEveryRoom(bookObj ? bookObj.all_room_books : [], pianoOrderConfig, room, forbiddenRooms)
            }
          }

          if (res.list.length % 3 !== 0) {
            let fillNum = 3 - res.list.length % 3
            while (fillNum > 0) {
              res.list.push({ fill_element: true })
              --fillNum
            }
          }
        }
        this.roomData = res.list
      } else {
        utils.judgeBackMsg(res)
        this.showReload = true
      }
    },
    // 在各琴房显示预约状态
    async getAllPianoConfig () {
      let sessionConfigInfo = api.getConfig()
      if (!sessionConfigInfo || sessionConfigInfo === 'null') {
        const cfg = await this.getConfig()
        sessionConfigInfo = cfg
      }
      const selDate = utils.formatDate(this.selDate + ' 00:00:00')

      const dateConfig = utils.refreshConfigData(selDate.getDay(), this.configInfo)
      const configStartTime = dateConfig.begin_time
      const configEndTime = dateConfig.end_time
      const start = configStartTime.split(':')
      const startHour = parseInt(start[0])
      const startMinutes = parseInt(start[1])
      const startTotalMinutes = startHour * 60 + startMinutes

      const end = configEndTime.split(':')
      const endHour = parseInt(end[0])
      const endMinutes = parseInt(end[1])
      const endTotalMinutes = endHour * 60 + endMinutes

      // 每段时间长度 分钟
      const eachLength = (this.configInfo && this.configInfo.base_span) || 30
      // 整个总时长
      const totalTime = endTotalMinutes - startTotalMinutes
      // 去除多余的时间，计算整个总时长可分成的段数
      const timeQuantumNum = (totalTime - totalTime % eachLength) / eachLength
      const timeQuantumList = []
      // 取段落从零开始计数
      let count = 0
      while (count < timeQuantumNum) {
        // 时间段开始时间
        const nodeStartTotalMinutes = startTotalMinutes + (count * eachLength)
        let nodeStartMinutes = nodeStartTotalMinutes % 60
        let nodeStartHour = (nodeStartTotalMinutes - nodeStartMinutes) / 60
        nodeStartMinutes = this.formatNumber(nodeStartMinutes)
        nodeStartHour = this.formatNumber(nodeStartHour)
        // 时间段结束时间
        const nodeEndTotalMinutes = nodeStartTotalMinutes + eachLength
        let nodeEndMinutes = nodeEndTotalMinutes % 60
        let nodeEndHour = (nodeEndTotalMinutes - nodeEndMinutes) / 60
        nodeEndMinutes = this.formatNumber(nodeEndMinutes)
        nodeEndHour = this.formatNumber(nodeEndHour)

        timeQuantumList.push({
          showTime: nodeStartHour + ':' + nodeStartMinutes + '-' + nodeEndHour + ':' + nodeEndMinutes,
          startTime: nodeStartHour + ':' + nodeStartMinutes,
          endTime: nodeEndHour + ':' + nodeEndMinutes,
          startTotalMinutes: nodeStartTotalMinutes,
          endTotalMinutes: nodeEndTotalMinutes,
          overdueCur: false, // 是否被占用 当使用和容量相等时为true或者已过期
          continuousCur: false, // 相对于被选中的时间段是否是可选的
          bookTotal: 0 // 预约的次数
        })
        ++count
      }
      return {
        selDate,
        timeQuantumList
      }
    },
    formatNumber (n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    async getTimeQuantumList (selectStartMinutes, selectEndMinutes) {
      const configInfo = await this.getConfig()
      this.getPianoTimeConfig()
      const configStartTime = configInfo.begin_time
      const configEndTime = configInfo.end_time
      const start = configStartTime.split(':')
      const startHour = parseInt(start[0])
      const startMinutes = parseInt(start[1])
      const startTotalMinutes = startHour * 60 + startMinutes

      const end = configEndTime.split(':')
      const endHour = parseInt(end[0])
      const endMinutes = parseInt(end[1])
      const endTotalMinutes = endHour * 60 + endMinutes

      // 每段时间长度 分钟
      const eachLength = (configInfo && configInfo.base_span) || 30
      // 整个总时长
      const totalTime = endTotalMinutes - startTotalMinutes
      // 去除多余的时间，计算整个总时长可分成的段数
      const timeQuantumNum = (totalTime - totalTime % eachLength) / eachLength
      const timeQuantumList = []
      // 取段落从零开始计数
      let count = 0
      while (count < timeQuantumNum) {
        // 时间段开始时间
        const nodeStartTotalMinutes = startTotalMinutes + (count * eachLength)
        let nodeStartMinutes = nodeStartTotalMinutes % 60
        let nodeStartHour = (nodeStartTotalMinutes - nodeStartMinutes) / 60
        nodeStartMinutes = this.formatNumber(nodeStartMinutes)
        nodeStartHour = this.formatNumber(nodeStartHour)
        // 时间段结束时间
        const nodeEndTotalMinutes = nodeStartTotalMinutes + eachLength
        let nodeEndMinutes = nodeEndTotalMinutes % 60
        let nodeEndHour = (nodeEndTotalMinutes - nodeEndMinutes) / 60
        nodeEndMinutes = this.formatNumber(nodeEndMinutes)
        nodeEndHour = this.formatNumber(nodeEndHour)

        if ((nodeStartTotalMinutes > selectStartMinutes && nodeStartTotalMinutes < selectEndMinutes) ||
          (nodeEndTotalMinutes > selectStartMinutes && nodeEndTotalMinutes < selectEndMinutes)
        ) {
          timeQuantumList.push({
            showTime: nodeStartHour + ':' + nodeStartMinutes + '-' + nodeEndHour + ':' + nodeEndMinutes,
            startTime: nodeStartHour + ':' + nodeStartMinutes,
            endTime: nodeEndHour + ':' + nodeEndMinutes,
            startTotalMinutes: nodeStartTotalMinutes,
            endTotalMinutes: nodeEndTotalMinutes,
            bookTotal: 0, // 预约次数
            occupation: 0 // 是否被占用 -1 不可预约， 0 未占用， 1 部分占用， 2 全部可用
          })
        }
        ++count
      }
      return timeQuantumList
    },
    // 获取楼层数据
    getBuildingInfo () {
      api.axiosRequest(api.urlList.getBuildingInfo, api.getPublicPara(true)).then((res) => {
        if (res && res.code === common.resCode.OK) {
          const list = res.list
          if (list) {
            const buildingList = []
            const buildingNo = []
            list.forEach(item => {
              if (buildingNo.indexOf(item.building_no) === -1) {
                buildingNo.push(item.building_no)
              }
            })
            buildingNo.forEach(item => {
              const itemBuilding = {
                buildingNo: item,
                title: item,
                layerData: []
              }

              list.forEach(itemTwo => {
                if (itemTwo.building_no === item) {
                  itemBuilding.layerData.push({
                    layerNo: itemTwo.building_floor,
                    title: itemTwo.building_floor,
                    title2: itemTwo.building_floor,
                    data: null,
                    image: ''
                  })
                }
              })

              buildingList.push(itemBuilding)
            })
            const bdData = buildingList[0]

            this.buildingData = buildingList
            this.selBuildingData = bdData
            this.selLayerData = bdData.layerData[0]
            this.layerModel = 1
            this.selRoomData = null
            this.getLayerRoom()
            this.getOnShow()
          }
        } else {
          // Toast.fail('没有获取到楼层数据')
          this.showReload = true
          this.roomData = null
          this.selRoomData = null
          this.roomScrollTop = 0
        }
      }).catch((e) => {
        console.log('error log:', e)
      })
    },
    async getPianoOneDayReservedEveryRoom (list, config, item, forbiddenRooms) {
      const that = this
      const seltDate = config.selDate
      const appointmentList = []
      const curTime = new Date()
      const difValue = that.dayDifValue(seltDate, curTime)
      const week = seltDate.getDay()
      let end
      if (difValue === 0) {
        // 此处为计算当前时间段与当天已过时间段
        const span = (this.configInfo && this.configInfo.base_span) || 30
        end = Math.floor((curTime.getHours() * 60 + curTime.getMinutes()) / span) * span
        // 添加上当前已经过去的时间段
        appointmentList.push({
          startTotalMinutes: 0,
          isExpire: true,
          // endTotalMinutes: curTime.getHours() * 60 + curTime.getMinutes() + 1
          endTotalMinutes: end
        })
      }
      try {
        const isForbidden = forbiddenRooms.find(function (o) {
          return parseInt(o.room_id) === parseInt(item.id)
        })
        if (isForbidden && Array.isArray(isForbidden.time_list)) {
          for (let i = 0; i < isForbidden.time_list.length; i++) {
            if (isForbidden.time_list[i].week_days.includes(week)) {
              const startSplit = isForbidden.time_list[i].start_time.split(':')
              const endSplit = isForbidden.time_list[i].end_time.split(':')
              appointmentList.push({
                startTotalMinutes: parseInt(startSplit[0]) * 60 + parseInt(startSplit[1]),
                isExpire: true,
                endTotalMinutes: parseInt(endSplit[0]) * 60 + parseInt(endSplit[1])
              })
            }
          }
        }
      } catch (e) {
        console.log(e)
      }

      const notAllowTimeList = that.getNotAllowTimeList(item.room_rule_list)
      if (Array.isArray(notAllowTimeList) && notAllowTimeList.length) {
        notAllowTimeList.forEach(item => {
          appointmentList.push({
            startTotalMinutes: item.startMinutes,
            isExpire: true,
            endTotalMinutes: item.endMinutes
          })
        })
      }

      let userId
      try {
        if (this.userInfoJSONParse) {
          userId = Number(this.userInfoJSONParse.userid)
        }
      } catch (e) {
        console.log(e)
      }
      for (let f = 0; f < list.length; ++f) {
        const c = list[f]

        const start = utils.formatDate(c.begin_time)
        const end = utils.formatDate(c.end_time)
        let isExpire = false
        if (c.status === 11) { // 课程
          isExpire = true
        } else if (c.status === 12) {
          isExpire = true
        } else if (c.user_id === userId) {
          isExpire = true
        }
        appointmentList.push({
          startTotalMinutes: start.getHours() * 60 + start.getMinutes(),
          endTotalMinutes: end.getHours() * 60 + end.getMinutes(),
          isExpire: isExpire
        })
      }
      const timeQuantumList = that.getTimeQuantumListEveryRoom(appointmentList, config.timeQuantumList, item.capacity, !!end)
      return timeQuantumList
    },
    getNotAllowTimeList (list) {
      const result = []
      if (Array.isArray(list) && list.length) {
        list.forEach(item => {
          const start = item.start_time.split(':')
          const end = item.end_time.split(':')
          item.startMinutes = parseInt(start[0]) * 60 + parseInt(start[1])
          item.endMinutes = parseInt(end[0]) * 60 + parseInt(end[1])
        })
        list.sort(function (a, b) {
          if (a.startMinutes === b.startMinutes) {
            return a.endMinutes - b.endMinutes
          }
          return a.startMinutes - b.startMinutes
        })
        let temp = 0
        do {
          const o = list.shift()
          const obj = {
            start: temp,
            end: o.startMinutes
          }
          if (temp < o.startMinutes) {
            let appointEnd = o.endMinutes
            for (let i = 0; i < list.length; i++) {
              if (list[i].startMinutes < o.endMinutes) {
                appointEnd = list[i].endMinutes
              }
            }
            temp = appointEnd
            result.push({
              startMinutes: obj.start,
              isExpire: true,
              endMinutes: obj.end
            })
          } else {
            temp = o.endMinutes
          }
        } while (list.length)
        if (temp < 1440) {
          result.push({
            startMinutes: temp,
            isExpire: true,
            endMinutes: 1440
          })
        }
      }
      if (result.length) {
        return result
      }
    },
    getTimeQuantumListEveryRoom (appointmentList, allBookSpan, capacity, isToday) {
      const timeQuantumList = JSON.parse(JSON.stringify(allBookSpan))
      const newStartTime = new Date()
      let startHours = newStartTime.getHours()
      let startMinutes = newStartTime.getMinutes()
      const minutesSpan = Math.ceil(startMinutes / 5)
      if (minutesSpan === 12) {
        startMinutes = 0
        startHours++
      } else {
        startMinutes = minutesSpan * 5
      }
      const newStartMinutesTotal = startHours * 60 + startMinutes
      for (let c = 0; c < timeQuantumList.length; ++c) {
        const timeQuantum = timeQuantumList[c]
        for (let f = 0; f < appointmentList.length; ++f) {
          const g = appointmentList[f]
          if (g.startTotalMinutes < timeQuantum.endTotalMinutes &&
            g.endTotalMinutes > timeQuantum.startTotalMinutes) {
            if (g.isExpire) {
              if (isToday && timeQuantum.endTotalMinutes > newStartMinutesTotal && timeQuantum.startTotalMinutes < newStartMinutesTotal) {
                if (g.endTotalMinutes > newStartMinutesTotal) {
                  timeQuantum.bookTotal++
                }
                if (timeQuantum.bookTotal >= capacity) {
                  timeQuantum.overdueCur = true
                } else {
                  const hStr = '00' + startHours
                  const mStr = '00' + startMinutes
                  timeQuantum.startTotalMinutes = newStartMinutesTotal
                  timeQuantum.startTime = `${hStr.substring(hStr.length - 2)}:${mStr.substring(mStr.length - 2)}`
                  timeQuantum.showTime = `${timeQuantum.startTime}-${timeQuantum.endTime}`
                }
              } else {
                timeQuantum.overdueCur = true
              }
            } else {
              timeQuantum.bookTotal++
              if (timeQuantum.bookTotal >= capacity) {
                timeQuantum.overdueCur = true
              }
            }
          }
        }
      }
      return timeQuantumList
    },
    // 选中房间
    selectRoom (item) {
      let toastMsg = null
      if (item.fill_element) {
        return false
      }
      if (item.status === 2) {
        toastMsg = '已被管理员锁定'
      } else if (item.self_special_owner === false ||
        item.self_special_room === false ||
        item.occupation === -1
      ) {
        // toast_msg = '您没有权限预约该琴房
        return false
      }
      if (toastMsg) {
        Toast.fail(toastMsg)
      } else {
        // 跳转到选择时间预约页面
        this.$router.push({
          path: '/pianoOrder',
          query: {
            roomId: item.id,
            typeName: item.type_name,
            roomName: item.name,
            buildingNo: this.selBuildingData.buildingNo,
            selDate: this.selDate + ' 00:00:00'
          }
        })
      }
    },
    handleScroll () {
      this.scrollHeight = this.$refs.scrollContainer.scrollTop
    },
    layerScroll () {
      this.scrollLayerLeft = this.$refs.layer.scrollLeft
    },
    getWin () {

    },
    getToday () {
      const selDate = new Date()
      const d = utils.formatTimeYMDInterval(selDate, '-')
      const dText = utils.formatTimeYMDChinese(selDate)
      this.selDate = d
      this.currentDate = new Date(d)
      this.selDateText = dText
      this.layerModel = 1
    },
    openTimePopup () {
      // this.getToday()
      this.showPopup = true
    },
    changeDayDate (index) {
      const date = new Date()

      date.setDate(date.getDate())
      const currentDateTime = utils.formatTimeYMDInterval(date)
      const newDate = new Date(currentDateTime)
      if (this.filterData.show) {
        this.filterData.show = false
      }
      this.currentDate = newDate

      this.timePickerConfirm()
    },
    jumpComplaint () {

    },

    getTimeColumnAndShowColumn () {
      // this.getPianoTimeConfig()
      if (this.configInfo) {
        const {
          // eslint-disable-next-line camelcase
          base_span,
          // eslint-disable-next-line camelcase
          allow_book_end_time,
          // eslint-disable-next-line camelcase
          allow_book_start_time
        } = this.configInfo

        const nowDate = utils.formatTimeYMDInterval(new Date(), '/')
        // eslint-disable-next-line camelcase
        let startTimeStamp = new Date(nowDate + ' ' + allow_book_start_time).getTime()
        // eslint-disable-next-line camelcase
        const limitMilSecond = base_span * 60000
        // eslint-disable-next-line camelcase
        const endTimeStamp = new Date(nowDate + ' ' + allow_book_end_time).getTime()
        const ls = []
        while (startTimeStamp < endTimeStamp) {
          ls.push(utils.formatTimeHourMinutes(new Date(startTimeStamp)))
          startTimeStamp += limitMilSecond
        }
        let tempStart = ''
        let tempEnd = ''
        let tempStartIndex = 0
        let tempEndIndex = 0
        if (this.filterData.startTime &&
          this.filterData.endTime) {
          ls.forEach((val, index) => {
            if (this.filterData.startTime === val) {
              tempStartIndex = index
              tempStart = val
            } else if (this.filterData.endTime === val) {
              tempEndIndex = index
              tempEnd = val
            }
          })
        }

        this.timeColumnList = ls
        this.filterData.startTime = tempStart
        this.filterData.endTime = tempEnd
        this.filterTempData.startTime = ls[tempStartIndex]
        this.filterTempData.endTime = ls[tempEndIndex]
        this.filterTempData.startIndex = [tempStartIndex]
        this.filterTempData.endIndex = [tempEndIndex]
        // 固定每列的值index
        let startIndex, endIndex
        for (let i = 0; i < this.timeColumnList.length; i++) {
          if (this.timeColumnList[i] === this.filterTempData.startTime) {
            startIndex = i
          }
          if (this.timeColumnList[i] === this.filterTempData.endTime) {
            endIndex = i
          }
        }

        this.filterTempData.comfirmDisabled = false

        this.columns[0].values = this.timeColumnList
        this.columns[0].defaultIndex = startIndex

        this.columns[1].values = this.timeColumnList
        this.columns[1].defaultIndex = endIndex
        // 弹出多列选择器
        this.filterData.show = true
      } else {
        this.$router.replace('/login')
      }
    },
    condition () {

    },

    bindDateChange () {

    },
    timePickerConfirm () {
      // 获取查询某天和对应的开放时间配置

      const week = this.currentDate.getDay()
      if (!this.judgeTodayIsOpenDay(week)) {
        return
      }
      this.getPianoTimeConfig(week)

      let aheadLimit = 0
      if (this.configData) {
        aheadLimit = this.configData.ahead_limit
      }

      const selDate = this.currentDate
      const difValue = this.dayDifValue(selDate, new Date())
      if (difValue < 0) {
        Toast('本时段暂不开放预约')

        return false
      } else if (aheadLimit >= 1) {
        if (difValue > aheadLimit - 1) {
          if (aheadLimit === 1) {
            Toast('本时段暂不开放预约')
          } else {
            Toast('本时段暂不开放预约')
          }
          return
        }
      }

      this.selDateText = utils.formatTimeYMDChinese(selDate)
      this.selDate = utils.formatTimeYMDInterval(selDate, '-')
      this.selectedDateIndex = difValue
      this.showPopup = false

      this.getLayerRoom()
    },
    timePickerCancel () {
      this.showPopup = false
    },
    closeTimePicker () {
      this.filterData.show = false
    },
    timesConfirm () {

    },
    timesCancel () {

    },
    getPianoTimeConfig (week, d) {
      // Toast.success('刷新配置')
      // const week = this.currentDate.getDay()
      const allconfigs = utils.refreshConfigData(week, d)

      // localStorage.setItem('configInfo', JSON.stringify(allconfigs))
      api.setConfig(JSON.stringify(allconfigs))
      this.configInfo = allconfigs
    },
    // 多列选择器 切换值
    timesChange (picker, value, index) {
      this.filterTempData.startTime = value[0]
      this.filterTempData.endTime = value[1]
    },
    doQuery () {
      let startIndex, endIndex
      for (let i = 0; i < this.timeColumnList.length; i++) {
        if (this.timeColumnList[i] === this.filterTempData.startTime) {
          startIndex = i
        }
        if (this.timeColumnList[i] === this.filterTempData.endTime) {
          endIndex = i
        }
      }

      if (startIndex >= endIndex) {
        Toast.fail('结束时间必须大于开始时间')
        return false
      }

      this.filterData.show = false

      this.getLayerRoom()
    },
    bindDateTimeChange (val) {
      let start = ''
      let end = ''
      if (val === 'am') {
        start = '06:00'
        end = '12:00'
      } else if (val === 'pm') {
        start = '12:00'
        end = '18:00'
      } else if (val === 'evening') {
        start = '18:00'
        end = '22:00'
      }

      this.filterData.startTime = start
      this.filterData.endTime = end
      this.filterData.show = false

      this.getLayerRoom()
    },
    feedBack () {
      this.$router.push('/feedBack')
    },
    async getConfig (val) {
      const para = {
        access_token: val || localStorage.getItem(common.keyAccessToken)
      }
      const res = await api.axiosRequest(common.baseUrlApiConfig + api.urlList.getConfig, para)
      if (res && res.code === common.resCode.OK) {
        res.base_span = res.base_span || 30
        res.startEndTimeExplain = res.begin_time + '-' + res.end_time
        api.setConfig(JSON.stringify(res))
        this.$store.commit('CONFIGINFO', JSON.stringify(res))
      }
      return res
    },
    checkCanUseStatus (room, selectSpanList, userId) {
      try {
        // 会插入一个变量 occupation 是否被占用: -2 锁定， -1 不可预约， 0 未占用， 1 部分占用， 2 全部可用
        const isSelToday = this.todayDate === this.selDate
        room.occupation = 0
        if (room.capacity <= 0) {
          // 没有容量
          room.occupation = -1
        } else if (room.status === 2) {
          // 房间锁定了
          room.occupation = -2
        } else if (room.self_special_owner === false || room.self_special_room === false) {
          // 因专项房间设置，没有该房间权限
          room.occupation = -1
        } else {
          if (selectSpanList.length === 0) {
            // 没有时间段可预约
            room.occupation = -1
            return
          }

          let allCanUse = true
          let partCanUse = false
          const currentDateTime = new Date()
          const currentMinutes = currentDateTime.getHours() * 60 + currentDateTime.getMinutes() + (currentDateTime.getSeconds() ? 1 : 0)
          if (Array.isArray(room.appoint_list) && room.appoint_list.length) {
            room.appoint_list.forEach((item) => {
              const startDateTime = utils.formatDate(item.begin_time)
              const endDateTime = utils.formatDate(item.end_time)
              item.startMinutes = startDateTime.getHours() * 60 + startDateTime.getMinutes()
              item.endMinutes = endDateTime.getHours() * 60 + endDateTime.getMinutes()
            })

            for (let j = 0; j < selectSpanList.length; j++) {
              room.appoint_list.forEach((item) => {
                if (isSelToday &&
                    (currentMinutes > selectSpanList[j].endTotalMinutes ||
                        currentMinutes > selectSpanList[j].startTotalMinutes)
                ) { // 当天的过期时间判断
                  selectSpanList[j].bookTotal = room.capacity
                } else if (selectSpanList[j].startTotalMinutes < item.endMinutes &&
                    selectSpanList[j].endTotalMinutes > item.startMinutes
                ) {
                  if (item.status === 11 || item.status === 12 || item.user_id === userId) {
                    selectSpanList[j].bookTotal = room.capacity
                  } else {
                    selectSpanList[j].bookTotal++
                  }
                }
              })
            }
            selectSpanList.forEach(function (item) {
              if (item.bookTotal < room.capacity) {
                partCanUse = true
              } else {
                partCanUse = partCanUse || false
                if (allCanUse) allCanUse = false
              }
            })
          } else if (isSelToday) {
            for (let j = 0; j < selectSpanList.length; j++) {
              if (currentMinutes > selectSpanList[j].endTotalMinutes ||
                  currentMinutes > selectSpanList[j].startTotalMinutes) {
                selectSpanList[j].bookTotal = room.capacity
              }
            }
            selectSpanList.forEach(function (item) {
              if (item.bookTotal < room.capacity) {
                partCanUse = true
              } else {
                partCanUse = partCanUse || false
                if (allCanUse) allCanUse = false
              }
            })
          }
          if (allCanUse) {
            room.occupation = 2
          } else {
            if (partCanUse) {
              room.occupation = 1
            } else {
              room.occupation = -1
            }
          }
        }
      } catch (e) {
      }
    },
    // 设置meta高度 解决安卓浏览器软键盘弹起，占用窗口的面积把元素顶起的问题
    setMetaHeight (height) {
      document.head.querySelector("meta[name='viewport']").setAttribute('id', 'viewportMeta')
      const metaEl = document.querySelector('#viewportMeta')
      const content = 'height=' + height + ',width=device-width,initial-scale=1.0,user-scalable=no'
      metaEl.setAttribute('name', 'viewport')
      metaEl.setAttribute('content', content)
      this.$forceUpdate()
    },
    mousedown (e) {
      if (e.button === 0) {
        this.layerSelected.selected = true
        this.layerSelected.x = e.pageX
      }
    },
    mousemove (e) {
      if (this.layerSelected.selected) {
        this.layerMove(e)
      }
    },
    mouseup (e) {
      if (e.button === 0 && this.layerSelected.selected) {
        this.layerSelected.selected = false
      }
    },
    mouseleave () {
      this.layerSelected.selected = false
    },
    layerMove (e) {
      const x = e.pageX
      const offset = x - this.layerSelected.x
      // 理论上要判断scrollLeft 有没有过边界，实际没有出现边界值忽略
      if (offset <= 0) {
        this.$refs.layer.scrollLeft = this.$refs.layer.scrollLeft + 5
      } else {
        this.$refs.layer.scrollLeft = this.$refs.layer.scrollLeft - 5
      }
      this.layerSelected.x = x
    }
  },
  beforeDestroy () {
    // 移除滚动事件监听
    this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll)
  },
  // keep-alive 生命周期 内重新赋值滚动高度
  activated () {
    this.$refs.scrollContainer.scrollTop = this.scrollHeight
    this.getMyOrder()
    if (!this.selBuildingData) {
      this.getBuildingInfo()
    } else {
      this.getLayerRoom()
    }
    if (this.$refs.layer && this.scrollLayerLeft) {
      this.$refs.layer.scrollLeft = this.scrollLayerLeft
    }
  }
}
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 3.75rem;

  .content_box {
    overflow-x: hidden;

    .complaint-wrap {
      display: flex;
      width: 100%;
      /* height: 80rpx; */
      align-items: center;
      /* background-color: #60B3FF; */
    }

    .condition-wrap {
      box-sizing: border-box;
      display: flex;
      width: 100%;
      height: 3.75rem;
      align-items: center;
      padding: 0 0.9375rem;
      justify-content: space-between;
      border-bottom: 0.4375rem solid #efefef;
      /* background-color: black; */
      .selectDayBox {
        display: flex;
      }
      .saoyisao {
        color: #74b0f9;
        font-size: 1.3125rem;
      }
    }

    .condition-data-date,
    .condition-data-time {
      width: 6.75rem;
      height: 1.75rem;
      line-height: 1.75rem;
      text-align: center;
      background: #ffffff;
      border-radius: 0.125rem;
      border: 0.0625rem solid #74b0f9;
    }

    .condition-data-time {
      margin-left: 0.375rem;
    }

    .conditionDataDateTimeDiv {
      width: 2.5rem;
      height: 1.25rem;
      line-height: 1.25rem;
      text-align: center;
      background: white;
      border-radius: 0.125rem;
      font-size: 0.75rem;
      color: #74b0f9;
      border: 0.0625rem solid #74b0f9;
    }

    .conditionDataDateTimeDiv.buildingParentected {
      color: white;
      background: #94c2fc;
    }

    .filter-fast-time-div {
      display: flex;
      margin-bottom: 0.9375rem;
    }

    .filter-fast-time-div .conditionDataDateTimeDiv {
      margin-right: 0.625rem;
    }

    .condition-date {
      display: flex;
      align-items: center;
      width: 14.5rem;
      height: 2rem;
      margin-left: 0.875rem;
      border: 0.0625rem solid #f1f1f1;
      border-radius: 1rem;
      background-color: #fff;
    }

    .filter-left-type {
      background-color: #74b0f9;
    }

    .condition-date-icon {
      width: 1.125rem;
      height: 1.125rem;
      margin-left: 1rem;
      margin-right: 0.625rem;
    }

    .condition-date-text {
      width: 13.125rem;
      color: #666;
      font-size: 0.875rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .condition > .filter {
      display: flex;
      height: 100%;
      align-items: center;
      margin-left: 1rem;
    }

    .condition > .filter > .text {
      margin-left: 5px;
      color: #fff;
      font-size: 1rem;
    }

    .buildingParent {
      // width: 100%;
      height: 2.75rem;
      display: flex;
      // justify-content: space-around;
      align-items: flex-end;
      /* background-color: #60B3FF; */
    }

    .buildingParent-x {
      display: flex;
      justify-content: space-around;
      align-items: flex-end;
      overflow-x: auto;
      justify-content: flex-start;
      padding-left: 0.4688rem;
      padding-right: 0.4688rem;
    }

    .buildingParent-x::-webkit-scrollbar {
      height: 0;
    }

    .buildingParent-x .building {
      margin-left: 0.4688rem;
      margin-right: 0.4688rem;
    }

    .building {
      height: 2.75rem;
      // width: 50%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .building > .text {
      /* width: 152rpx; */
      height: 1.875rem;
      line-height: 1.875rem;
      text-align: center;
      padding-left: 0.625rem;
      padding-right: 0.625rem;
      border-radius: 16px;
      border: 1px solid transparent;
      color: #efefef;
      font-size: 1.125rem;
    }

    .building > .icon {
      width: 0.9375rem;
      height: 0.3125rem;
      /* width: 0;
  height: 0;
  border: 15rpx solid transparent;
  margin-top: -5rpx;
  border-bottom-color: transparent; */
    }

    .building.buildingParent > .text {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303133;
      border: 0.0625rem solid #fff;
    }

    /* .building.buildingParent>.icon{
  border-bottom-color: #fff;
} */
    .buildingParentect {
      width: 100%;
      height: 3rem;
      padding-right: 0.75rem;
      align-items: center;
      background-color: #fff;
    }
    .outer-layerParent,.inner-layerParent{
      width: 100%;
      overflow: hidden;
    }
    .layerParent {
      box-sizing: border-box;
      margin-top: 0.4375rem;
      display: flex;
      width: 100%;
      height: 100%;
      padding-left: 0.9375rem;
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      };
      -webkit-appearance: none;
      scrollbar-width: none;
      -moz-appearance: none;
      -ms-overflow-style:none;
    }

    .layerParentX {
      overflow-x: auto;
    }

    .layerParentX::-webkit-scrollbar {
      height: 0;
    }

    .layerParent .item {
      // width: inherit;
      // width: -webkit-fill-available;
      width: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      margin-top: 0.25rem;
      margin-right: 0.9375rem;
      /* min-width: 200rpx; */
      height: 1.375rem;
      padding: 0  1.25rem;
      border-radius: 0.6875rem;
      background: #deedff;
      font-size: 0.375rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #606266;
      border: 0.125rem solid #b3d4ff;
    }

    .layerParent .item .text {
      /* height: 80rpx;
  line-height: 80rpx; */
      text-align: center;
      font-size: 1rem;
      flex-grow: 1;
      color: #74b0f9;
    }

    .item.buildingParent {
      background-color: #74b0f9;
    }

    .layerParent .item.buildingParent .text {
      color: white;
    }

    /* .itemTwo .item.buildingParent .indicator{
  background-color: #0086ff;
} */
    .piano-room-show-image {
      display: block;
      width: 100%;
      height: 100%;
    }

    .svg-image {
      transform: translate3d(0, 0, 0) scale(0.25, 0.25);
      transform-origin: left top;
    }

    .index-qinfang-wrap {
      /* display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto; */
      position: absolute;
      margin: 0;
      padding: 0;
      // top: topWrapHeight;   // 当前用户缺失人脸时 顶部通知会往下顶 距离上方距离需要为11
      right: 0px;
      bottom: 4rem;
      left: 0px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      };
      -webkit-appearance: none;
      scrollbar-width: none;
      -moz-appearance: none;
      -ms-overflow-style:none;
    }

    .room-list {
      position: absolute;
      left: 0.75rem;
      top: 0;
      right: 0.75rem;
      bottom: 0;
      display: flex;
      flex-wrap: wrap;
      /* align-items: flex-start; */
      align-content: flex-start;
      justify-content: space-between;
    }

    .room {
      position: relative;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 6.75rem;
      // height: 3.9375rem;
      // margin-left: 0.3125rem;
      // margin-right: 0.3125rem;
      margin-top: 0.875rem;
      border-radius: 0.25rem;
      box-shadow: 0px 0px 2px 0px rgba(208, 208, 208, 0.5);
    }

    .room .room-top {
      position: relative;
      flex-shrink: 0;
    }

    .room .back-img-wrap {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 0;
    }

    .room .back-img-wrap > img {
      width: 100%;
      height: 100%;
    }

    .room .room-up {
      padding: 0 0.625rem 0;
      height: 2.25rem;
      position: relative;
      display: flex;
      align-items: center;
      /* background: #E8F4FF; */
      border-radius: 0.25rem 0.25rem 0 0;
    }

    .room .many-room-up {
      padding: 0 0.425rem 0;
    }

    .room .room-down {
      padding: 0 0.3125rem 0;
      height: 1.6rem;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .room .roomBookDetail {
      padding: 0.125rem;
      position: relative;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
    }

    .room .allOrder {
      background: linear-gradient(to bottom, #e5efff, #a0c0fd);
    }

    .room .partOrder {
      background: linear-gradient(to bottom, #dcf9e5, #b4fac4);
    }

    .room .disableOrder {
      background: linear-gradient(to bottom, #f3f3f3, #e9e9e9);
    }

    .room .lockOrder {
      background: linear-gradient(to bottom, #fefbe2, #f3e97f);
    }

    .room .roomBookDetailItem {
      flex-shrink: 0;
      width: 30%;
      // width: 2rem;

      // font-size: 0.3125rem;
      // transform: scale(0.2); // 将字体缩小
      // transform-origin: 0 0;
    }

    .room .roomBookDetailItem span {
      display: block;
      text-align: center;
      color: black;
      font-weight: bold;
      font-size: 0.75rem;
      transform: scale(0.4); // 将字体缩小
      transform-origin: 0 0;
    }

    .room .line-through span {
      text-decoration: line-through;
      color: lightgray;
    }

    .room .room-book-detail-empty {
      flex-shrink: 0;
      width: 30%;
      /* padding: 0 4rpx; */
    }

    .room .no-text {
      font-size: 1.25rem;
      color: #384f64;
      font-weight: bold;
      overflow: hidden;
    }

    .room .many-no-text {
      font-size: 0.7rem;
    }

    .room .has-window {
      position: absolute;
      right: 0.375rem;
      width: 1.25rem;
      height: 1.25rem;
    }

    .room .device-name {
      font-size: 1.25rem;
      color: #666;
    }

    .room .device-name text {
      font-weight: 550;
    }

    .room .type-text {
      font-size: 0.6875rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
      overflow: hidden;
    }

    .reload-room {
      position: absolute;
      width: 5rem;
      height: 2.5rem;
      line-height: 2.5rem;
      text-align: center;
      margin-top: 45%;
      margin-left: 9.375rem;
      color: #666;
      font-size: 0.9375rem;
      border: 1px solid #e1e1e1;
      border-radius: 1.25rem;
    }

    .room-bottom-fill {
      width: 100%;
      height: 0.8125rem;
    }

    .room-bottom-fill-buildingParent {
      width: 100%;
      height: 8.1875rem;
    }

    .subscribe-parent {
      position: absolute;
      height: 11.375rem;
      left: 0px;
      right: 0px;
      bottom: 0px;
      display: flex;
      flex-direction: column;
      box-shadow: 0 1px 0.1563rem 1px rgba(1, 1, 1, 0.1);
    }

    .subscribe-top {
      position: relative;
      width: 100%;
      height: 7.625rem;
      box-sizing: border-box;
      padding-left: 0.875rem;
      padding-right: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #fff;
    }

    .subscribe-close {
      position: absolute;
      right: 1rem;
      top: 1rem;
      width: 1.25rem;
      height: 1.25rem;
    }

    .subscribe-address {
      color: #333;
      font-size: 1.125rem;
    }

    .subscribe-time-parent {
      display: flex;
      align-items: center;
      margin-top: 0.5rem;
    }

    .subscribe-time-hint {
      color: #666;
      font-size: 0.875rem;
    }

    .subscribe-time {
      color: #007dff;
      font-size: 0.875rem;
    }

    .subscribe-dispose {
      display: flex;
      align-items: center;
      margin-top: 0.625rem;
    }

    .subscribe-dispose .type-name {
      font-size: 0.75rem;
      color: #9b7a3f;
      padding: 0.25rem 0.5rem;
      background-color: #f7f3ec;
      border-radius: 0.125rem;
    }

    .subscribe-dispose .has-instrument,
    .subscribe-dispose .has-window {
      margin-left: 0.375rem;
      padding: 0.25rem 0.5rem;
      font-size: 0.75rem;
      color: #333;
      border-radius: 0.125rem;
      background-color: #ececec;
    }

    .subscribe {
      flex-grow: 1;
      background-color: #ff9d00;
      line-height: 3.75rem;
      text-align: center;
      color: #fff;
      font-size: 1.25rem;
    }

    .room-type-list-1 {
      position: absolute;
      top: 10rem;
      left: 1rem;
      right: 0.875rem;
      bottom: 5.625rem;
    }

    .room-type-list-2 {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: flex-start;
    }

    .room-type {
      height: 2rem;
      line-height: 2rem;
      padding: 0 0.625rem;
      margin: 0 0.625rem 0.5rem 0;
      font-size: 0.75rem;
      font-weight: bold;
      color: #666;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.25rem;
    }

    .room-type.buildingParent {
      color: #fff;
      background-color: #ff9d00;
      border-radius: 0.25rem;
    }

    .filter-div-wrap {
      position: absolute;
      height: 2.5rem;
      right: 1rem;
      bottom: 1.5625rem;
      left: 1rem;
      display: flex;
      align-items: center;
      border-radius: 1.25rem;
      overflow: hidden;
    }

    .filter-div-item {
      display: flex;
      width: 50%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 1.25rem;
    }

    .filter-time {
      width: 6.25rem;
      height: 2.375rem;
      line-height: 2.375rem;
      text-align: center;
      border-radius: 0.25rem;
      border: 1px solid #dadada;
      color: #999;
      font-weight: bold;
      font-size: 0.75rem;
    }

    .filter-time.buildingParent {
      color: #333;
    }

    .view {
      position: fixed;
      height: 3.75rem;
      width: 3.75rem;
      border-radius: 50%;
      color: white;
      text-align: center;
    }

    .time-picker-filter {
      position: fixed;
      right: 0;
      bottom: 0px;
      left: 0;
      box-sizing: border-box;
      padding: 0.9375rem 0.875rem;
      background-color: white;
      z-index: 10000;
    }

    .time-picker-filter-top {
      display: flex;
      align-items: center;
      margin-bottom: 1.25rem;
      justify-content: space-between;
    }

    .time-picker-filter-top-left {
      height: 1.125rem;
      font-size: 0.9375rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #74b0f9;
      line-height: 1.125rem;
    }

    .time-picker-filter-top-close {
      width: 0.9375rem;
      height: 0.9375rem;
    }

    .filter-time-picker-wrap {
      display: flex;
      justify-content: center;
    }

    .time-picker-start-wrap,
    .time-picker-end-wrap {
      width: 9.375rem;
      text-align: center;
    }

    .filter-zhi {
      padding-bottom: 0.3125rem;
      font-size: 1rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
    }

    .temp-time-wrap {
      display: flex;
      justify-content: center;
      text-align: center;
      margin-bottom: 0.625rem;
    }

    .temp-time-text {
      width: 5rem;
      padding-bottom: 0.3125rem;
      font-size: 1rem;
      white-space: nowrap;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
      border-bottom: 1px solid #999999;
    }

    .temp-time-text.val {
      color: #74b0f9;
      border-bottom: 1px solid #74b0f9;
    }

    .book-confirm-div-bottom {
      display: flex;
      height: 2.5rem;
      justify-content: flex-end;
    }

    .book-comfirm-div-wrap {
      height: 100%;
    }

    .book-comfirm-div-wrap > .doneBtn {
      background-color: #74b0f9;
      color: white;
    }

    .bottom-time-filter-picker {
      width: 100%;
      height: 12.5rem;
    }

    .bottom-time-filter-picker-indicator {
      height: 2.5rem;
      color: white;
      /* background: #74B0F9; */
    }

    // add
    .emptyBox {
      width: 100%;
      display: flex;
      justify-content: center;
    }

  }
}
.fade-enter-active,
.fade-leave-active {
  background-color: black;
  transition: opacity 1.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
